import { ViewRef } from '@angular/core';

export function canAbilityCdRef(): boolean {
  return this.cdRef && !(this.cdRef as ViewRef).destroyed;
}
